export default {
    '.SnackbarItem-contentRoot': {
        boxShadow: '0px 8px 24px 0px rgba(0, 0, 0, 0.20) !important',
    },
};
